import { render, staticRenderFns } from "./GiftMenuContent.vue?vue&type=template&id=2ea48e15&"
import script from "./GiftMenuContent.vue?vue&type=script&lang=js&"
export * from "./GiftMenuContent.vue?vue&type=script&lang=js&"
import style0 from "./GiftMenuContent.vue?vue&type=style&index=0&id=2ea48e15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports